import { Injectable } from "@angular/core";
import { AyudaChannel, AyudaFormSubmitEvent } from "ras-ayuda";
import { take } from "rxjs/operators";
import { GtmDatalayerUiService } from "../gtm-datalayer/gtm-datalayer-ui.service";
import { AyudaDataService } from '../data/ayuda-data.service';

@Injectable({
  providedIn: 'root'
})
export class AyudaClientService {
  constructor(private ayudaDataService: AyudaDataService,
    private gtmDataLayerUiService: GtmDatalayerUiService) { }

  public handleChannelSelection(channel: AyudaChannel) {
    switch (channel) {
      case AyudaChannel.Chat:
        // Data Layer and Other Entries
        this.gtmDataLayerUiService.addAyudaFormEvent('chat').pipe(take(1)).subscribe({
          next: () => {
          }
        });
        break;
      case AyudaChannel.WhatsApp:
        // Data Layer and Other Entries
        this.gtmDataLayerUiService.addAyudaFormEvent('whatsapp').pipe(take(1)).subscribe({
          next: () => {
          }
        });
        break;
      default:
        break;
    }
  }

  public handleFormRequest(event: AyudaFormSubmitEvent): void {
    if (event.channel === AyudaChannel.CallMeBack) {
      this.gtmDataLayerUiService.addAyudaFormEvent('tellamamos').pipe(take(1)).subscribe({
        next: () => {
        }
      });

      this.ayudaDataService.saveCmbRequest(event.formData).pipe(take(1)).subscribe({
        next: (d) => {
        }
      });
    } else if (event.channel === AyudaChannel.Email) {
      this.gtmDataLayerUiService.addAyudaFormEvent('email').pipe(take(1)).subscribe({
        next: () => {
        }
      });

      this.ayudaDataService.saveEmailRequest(event.formData).pipe(take(1)).subscribe({
        next: (d) => {
        }
      });
    }
  }
}
